import Head from 'next/head';
import React from 'react';

const Page = ({ title }: { title: string }) => {
  return (
    <Head>
      <title>{title}</title>
      <meta
        name='description'
        content='HubSpot Payment integration to receive payments in HubSpot CRM'
        key='desc'
      />
    </Head>
  );
};

export default Page;
